import {
  Box,
  Divider,
  Stack,
  Tag,
  TagLabel,
  Text,
  Spacer,
  Flex,
  Radio,
  RadioGroup,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { getUpdatedObjectFilterRegionsParams } from '../../../../services/Objects/RegionListService';
import { ObjectsParams } from '../../../../types/ParamsTypes';
import { ObjectsRegions } from '../../../../types/ObjectsTypes';

export interface RegionListProps {
  regions: ObjectsRegions;
  objectsParams: ObjectsParams;
  onFilterChange: (objectsParams: ObjectsParams) => void;
}

export const RegionList = (props: RegionListProps): JSX.Element => {
  const { regions, objectsParams, onFilterChange } = props;

  const handleChange = useCallback(
    (value: string) => {
      const result = getUpdatedObjectFilterRegionsParams(objectsParams, value);
      onFilterChange(result);
    },
    [objectsParams, onFilterChange],
  );

  return (
    <Box>
      <Text textStyle={'category.primary'}>Regionen</Text>
      <Divider mt={1} mb={4} />
      <RadioGroup
        value={objectsParams.regions.length === 0 ? 'all' : objectsParams.regions[0]}
        onChange={handleChange}>
        <Stack spacing={4} direction="column">
          <Flex>
            <Radio value={'all'} isChecked={true}>
              Beliebig
            </Radio>
          </Flex>
          {regions.regions.map((region, idx) => {
            return (
              <Flex key={idx}>
                <Radio value={region.uniqueId} size="md" colorScheme="blue" width={'100%'}>
                  <Text fontSize={'md'}>{region.Title}</Text>
                </Radio>
                <Spacer />
                <Tag minW={'auto'}>
                  <TagLabel>{region.quantity}</TagLabel>
                </Tag>
              </Flex>
            );
          })}
          ¿
        </Stack>
      </RadioGroup>
    </Box>
  );
};
